import React, { useMemo } from 'react';
import { createStyleSheet, removeBreakLines } from '../../../utils';
import { useStyleSheet } from '../../../hooks';
import { View } from '../../View';
import { Text } from '../../Text';
import { IconButton } from '../../IconButton';
import { TextBlock } from '../../Message';
export const Template = ({ data, onSend, onEdit, onDelete, isEditingEnabled }) => {
    const styles = useStyleSheet(getStyles);
    const body = useMemo(() => removeBreakLines(data.data), [data]);
    return (React.createElement(View, { style: styles.container },
        React.createElement(Text, { type: 'headline', size: 'md' }, data.name),
        React.createElement(TextBlock, { data: body, style: styles.body, numberOfLines: 3 }),
        React.createElement(View, { style: styles.actions },
            React.createElement(View, { style: styles.actionsWrapper },
                React.createElement(IconButton, { value: 'edit', type: 'secondary', size: 'xs', accent: 'neutral', onPress: () => {
                        onEdit(data);
                    }, disabled: !isEditingEnabled }),
                React.createElement(IconButton, { value: 'delete', type: 'secondary', size: 'xs', accent: 'negative', onPress: () => {
                        onDelete(data);
                    }, style: styles.action__withMargin, disabled: !isEditingEnabled })),
            React.createElement(IconButton, { value: 'arrow-up', type: 'primary', size: 'xs', accent: 'default', onPress: () => {
                    onSend(data);
                } }))));
};
const getStyles = createStyleSheet(({ size }) => ({
    container: {
        padding: size.E,
        paddingRight: 0
    },
    body: {
        marginTop: size.C
    },
    actions: {
        flexDirection: 'row',
        alignItems: 'center',
        marginTop: size.E
    },
    action__withMargin: {
        marginLeft: size.C
    },
    actionsWrapper: {
        flex: 1,
        flexDirection: 'row',
        alignItems: 'center'
    }
}));
//# sourceMappingURL=Template.js.map